import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSpring, animated } from 'react-spring'
import {
    faBuilding,
    faSave,
    faSign,
    faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import Loading from '../loading'

const ModalEditDepartment = ({
    showModal,
    setShowModal,
    handlerSubmit,
    loadData,
    id,
    selectOrganization,
}) => {
    // START MODAL
    const modalRef = useRef()

    const animation = useSpring({
        config: {
            duration: 250,
        },
        opacity: showModal ? 1 : 0,
        transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
    })

    const keyPress = useCallback(
        (e) => {
            if (e.key === 'Escape' && showModal) {
                setShowModal(false)
                console.log('I pressed')
            }
        },
        [setShowModal, showModal]
    )

    useEffect(() => {
        document.addEventListener('keydown', keyPress)
        return () => document.removeEventListener('keydown', keyPress)
    }, [keyPress])

    // END MODAL

    const [addData, setAddData] = useState({ id: id })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getData()
    }, [])
    const getData = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/department/one/${id}`,
            },
            resolve: (res) => {
                setAddData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور')
            },
        })
    }

    const handlerSubmitModal = async () => {
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'patch',
                url: `/department/${id}`,
                data: {
                    name: addData.name,
                    parent_id: addData.parent_id,
                    organization_id: selectOrganization,
                },
            },
            resolve: (res) => {
                loadData()
                setShowModal((prev) => !prev)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'name':
                setAddData({ ...addData, name: e.target.value })
                break
            default:
                return null
        }
    }

    return (
        <>
            {loading ? <Loading /> : null}

            {showModal ? (
                <div
                    className="modal-components-background"
                    // onClick={closeModal}
                    ref={modalRef}
                >
                    <animated.div
                        style={animation}
                        className="modal-components-background-content"
                    >
                        <div className="modal-components-warpper">
                            <div className="bg-white rounded-xl shadow-xl w-full">
                                {/* Modal Header */}
                                <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-t-xl">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-xl font-bold text-white flex items-center">
                                            <FontAwesomeIcon
                                                icon={faBuilding}
                                                className="ml-2"
                                            />
                                            ویرایش بخش کاری
                                        </h2>
                                        <button
                                            onClick={() => setShowModal(false)}
                                            className="text-white hover:text-gray-200"
                                        >
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                size="lg"
                                            />
                                        </button>
                                    </div>
                                </div>

                                {/* Modal Content */}
                                <div className="p-6 space-y-4">
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700 flex items-center">
                                            <FontAwesomeIcon
                                                icon={faSign}
                                                className="ml-2 text-gray-500"
                                            />
                                            نام بخش کاری
                                        </label>
                                        <input
                                            type="text"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            value={addData.name}
                                            onChange={(e) =>
                                                setQueryPropertyAddData(
                                                    'name',
                                                    e
                                                )
                                            }
                                            placeholder="نام بخش کاری را وارد کنید"
                                        />
                                    </div>
                                </div>

                                {/* Modal Footer */}
                                <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3 space-x-reverse">
                                    <button
                                        onClick={() => setShowModal(false)}
                                        className="px-6 py-2 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="ml-2"
                                        />
                                        انصراف
                                    </button>
                                    <button
                                        onClick={handlerSubmitModal}
                                        className="px-6 py-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all flex items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={faSave}
                                            className="ml-2"
                                        />
                                        ویرایش بخش کاری
                                    </button>
                                </div>
                            </div>
                        </div>
                    </animated.div>
                </div>
            ) : null}
        </>
    )
}

export default ModalEditDepartment
